import { Component, EventEmitter, Input, Output, TemplateRef, inject } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { IconColor, IconSize, IconWeight } from '@widgets/eop-icon/eop-icon.component';
import { ChipColor } from '@widgets/eop-chip/data/eop-chip.data';

export interface ValueWithLink {
  value: string;
  link: string;
  navigationExtras: NavigationExtras;
}

export interface ValueWithAdditionalTooltip {
  value: string;
  additionalTooltipText: string;
}

@Component({
  selector: 'form-element',
  templateUrl: 'form-element.component.html',
  styleUrls: ['form-element.component.scss'],
  standalone: false,
})
export class FormElementComponent {
  private readonly router = inject(Router);

  @Input()
  label: string;
  @Input()
  valuesWithLink: ValueWithLink[];
  @Input()
  classWidth: string;
  @Input()
  mandatory: boolean;
  @Input()
  iconIdentifier: string;
  @Input()
  iconWeight: IconWeight;
  @Input()
  iconSize: IconSize;
  @Input()
  iconText: string;
  @Input()
  infoTextColor: IconColor;
  @Input()
  iconTooltip: string;
  @Input()
  iconTextColor: IconColor;
  @Input()
  disabled: boolean;
  @Input()
  showWaitIcon: boolean;
  @Input()
  infoText: string;
  @Input()
  contentTemplate: TemplateRef<any>;
  @Input()
  headerChipValue: string;
  @Input()
  headerChipColor = ChipColor.DEFAULT;
  @Input()
  headerChipTooltipText: string;
  @Input()
  headerChipClickable = false;
  @Input()
  footerText: string;
  @Input()
  footerIconIdentifier: string;
  @Input()
  footerIconColor: IconColor = IconColor.DEFAULT;
  @Input()
  chipValue: string;
  @Input()
  chipColor = ChipColor.DEFAULT;
  @Input()
  chipTooltipText: string;
  @Input()
  chipEmphasized = true;
  @Input()
  hideTextOverflow = false;
  @Input()
  slashSeparatedValues = false;
  @Input()
  breakLines = false;
  @Output()
  iconClicked: EventEmitter<any> = new EventEmitter();
  @Output()
  chipClicked: EventEmitter<any> = new EventEmitter();

  protected readonly IconWeight = IconWeight;
  protected readonly IconSize = IconSize;
  protected readonly IconColor = IconColor;

  _values: (ValueWithAdditionalTooltip | string | number | boolean)[] = [];

  @Input()
  set values(val: (ValueWithAdditionalTooltip | string | number | boolean)[]) {
    if (!val) {
      this._values = [];
    }
    this._values = val.filter(value => !!value);
  }

  iconClick(): void {
    this.iconClicked.emit();
  }

  onChipClick(): void {
    this.chipClicked.emit();
  }

  navigateRoute(valueWithLink: ValueWithLink): void {
    this.router.navigate([valueWithLink.link], valueWithLink.navigationExtras);
  }
}
